import { render, staticRenderFns } from "./AddFacility.vue?vue&type=template&id=c46ce282&scoped=true&"
import script from "./AddFacility.vue?vue&type=script&lang=js&"
export * from "./AddFacility.vue?vue&type=script&lang=js&"
import style0 from "./AddFacility.vue?vue&type=style&index=0&id=c46ce282&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46ce282",
  null
  
)

export default component.exports